// ANGULAR
import { Injectable } from '@angular/core';

// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

// RXJS
import { Observable, of } from 'rxjs';
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators';

// EXTERNAL DEPENDENCY
import { get } from 'lodash';

// SERVICES
import { NewsFeedService } from '../services/news-feed.service';

// ACTIONS AND STATES
import * as globalActions from '../../../global/store/actions';
import { State } from '../../../root-state';
import * as NewsFeedActions from './actions';

// COMMON INTERFACES AND ENUMS
import { ModalType } from '../../../../models/common/modal/modal-config';

// CONSTANT
import { NEWS_FEED_NGRX_CONSTANTS } from '../../../../constants/ngrx-store/news-feed';


/**
 * This effect is for listen NewsFeed actions, execute NewsFeed service call and dispatch in NewsFeed reducer.
 * For NewsFeed api call purpose.
 *
 * @author Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 18/06/2020 (Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>)  created NewsFeed effect
 */
@Injectable()
export class NewsFeedEffects {
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private newsFeedService: NewsFeedService) { }

  /**
   * @param type : NewsFeed action name.
		  * NewsFeed Effect
		  * @param payload : object to identify common NewsFeed method base on module and method.
		  * @returns Empty action dispatch to reducer.
		  */
  NewsFeedCommonEffect$ = createEffect(() => this.actions$.pipe(
    ofType<NewsFeedActions.NewsFeedCommonAction>(NewsFeedActions.ActionTypes.NEWS_FEED_COMMON),
    withLatestFrom(this.store),
    mergeMap(([action, state]): Observable<any> => {
      // get common constant base action module and method.
      // changed to payload type from payload.data.method
      const common = NEWS_FEED_NGRX_CONSTANTS[action.payload.module][action.payload.method];

      // Per-state-key cache short-circuit removed: it caches PER STATE KEY (not
      // per payload), so any re-fetch on the same method (Reset, filter, page
      // change, refresh) was silently dropped and the host component's
      // `loading` flag stayed `true`. Components own their refetch policy.

      return this.newsFeedService[common.API_METHOD](action.payload.data)
        .pipe(

          mergeMap((data: any) => {
            // throwing an error on if the status is not 200
          //  if (data.status !== 200) { return throwError(data); }
            let actions: any[] = [];


            // dispatch NewsFeed success action
            actions = [new NewsFeedActions.NewsFeedCommonSuccessAction({ data, common })];

            if (common.SUCCESS_NOTIFICATION) {
              // dispatch popup notification for open success popup
              actions.push(new globalActions.PopupNotificationAction({
                actionType: NewsFeedActions.ActionTypes.NEWS_FEED_COMMON, type: ModalType.SUCCESS,
                callback: action.payload.callback, title: common.TITLE, message: common.SUCCESS,
                code: `${common.SUCCESS}`, response: data,
              }));
            } else {
              action.payload && action.payload.callback && action.payload.callback({ success: true, data: get(data, common.API_RESPONSE) });
            }

            return actions;
          }),
          catchError(error =>
            // dispatch popup notification for open error popup
            of(new globalActions.PopupNotificationAction({
              actionType: NewsFeedActions.ActionTypes.NEWS_FEED_COMMON, type: ModalType.ERROR,
              message: error && error.error && error.error.message, callback: action.payload.callback, error: (error || error.error),
              // code: `ERROR.${error.code || error.error.code}`,
              title: common.TITLE,
            }))));
    }),
  ));
}
